
import React, { useMemo, useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import { useLocation, useNavigate } from 'react-router-dom';
import LinkInvestMent from './LinkInvestMent';
import ManageInvestment from './ManageInvestment';
import { useLanguage } from '../../Providers/LanguageContext';

const LinkManageInvestment = () => {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const sliderRef = useRef(null);
    const [linkedAccData, setLinkedAccData] = useState([]);
    const [callGetAcc, setCallGetAcc] = useState(false);
    const [buttonText, setButtonText] = useState(language.view_manage_docs);
    const [slideIndex, setSlideIndex] = useState(0);
    const [initialSlide, setInitialSlide] = useState(0);

    // const getInitialSlideMemo = useMemo(() => {
    //     if (location?.state?.slideNo === 1) {
    //         return 1;
    //     }
    //     else return 0;
    // }, [location]);

    useEffect(() => {
        if (location?.state?.slideNo === 1) {
            setInitialSlide(1);
            setButtonText(language.link_investment);
            handleButtonClick()
        } else {
            setInitialSlide(0);
            setButtonText(language.view_manage_docs);
        }
    }, [location, language]);

    // Slider settings
    const settings = {
        dots: false,
        infinite: false,
        // swipe: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        // initialSlide: initialSlide,
        // initialSlide: getInitialSlideMemo,
        afterChange: (index) => setSlideIndex(index),
    };

    // Handle button click 
    const handleButtonClick = () => {
        if (buttonText === language.view_manage_docs) {
            setButtonText(language.link_investment);
            sliderRef.current.slickGoTo(1);
        } else {
            setButtonText(language.view_manage_docs);
            sliderRef.current.slickGoTo(0);
        }
    };

    useEffect(()=>{
      window.scrollTo({top:'0',behavior:'instant'})
    },[])

    return (
        <section style={{
            background: 'linear-gradient(rgb(15, 36, 55), rgb(255, 255, 255))', padding: '20px 0px;'
        }}>

            <div className='container-fluid'>


                <div className='task_head'>{language.inv_manager} - {language.link_manage_inv}</div>


                <div className="chart-slide border border-5 border-light mt-3 " style={{
                    padding:'20px',
                    borderRadius:'15px'
                }}>
                    <div className='d-flex gap-2 mb-2 navigation_buttons_wrapper '>
                        <div className=''>
                            <button className='slctUser' style={{
                                background: '#88e884',
                                color: '#0c2637'
                            }} onClick={() => navigate('/investment-options')}>{language.investment_option}</button>
                        </div>

                        <div className=''>
                            <button className='slctUser' style={{
                                background: '#88e884',
                                color: '#0c2637'
                            }} onClick={handleButtonClick}>
                                {buttonText}
                            </button>
                        </div>
                    </div>
                    <div className="">
                        <Slider {...settings} ref={sliderRef}>
                            <div>
                                <LinkInvestMent
                                    setLinkedAccData={setLinkedAccData}
                                    callGetAcc={callGetAcc}
                                />
                            </div>

                            <div>
                                <ManageInvestment
                                    linkedAccData={linkedAccData}
                                    setCallGetAcc={setCallGetAcc}
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LinkManageInvestment;

